<template>
  <router-view/>
</template>

<script>
export default {
  created() {
    const _nu = navigator.userAgent
    if ((/AppleWebKit.*Mobile/i.test(_nu) || /Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test(_nu) || /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(_nu)) && !/iPad/i.test(_nu) && location.hash != '#m') {
      window.location.href = window.location.href.replace("/pc/", "/m/")
    }
  }
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
    font-family: '苹方', 'Microsoft Yahei', Helvetica, sans-serif;
  }
  body{
    background: #FBFBFD;
  }
</style>